import { getVideoEmbedSrc, escapeHTML, isValidUrl } from './utils';

document.addEventListener('DOMContentLoaded', function () {
	const modalHTML = `<div id="global-modal" class="modal" tabindex="-1" aria-hidden="true" role="dialog"><div class="modal-holder"><div class="modal-content"><button type="button" class="close-modal" aria-label="${knightowl_translations.close}"><span aria-hidden="true">×</span></button><div class="modal-body"></div></div></div></div>`;
	document.body.insertAdjacentHTML('beforeend', modalHTML);

	const modal = document.getElementById('global-modal');
	const modalHolder = modal.querySelector('.modal-holder');
	const modalContent = modal.querySelector('.modal-content');
	const modalBody = modalContent.querySelector('.modal-body');

	if (modal) {
		const modalBtns = document.querySelectorAll('.modal-open');

		if (modalBtns.length) {
			modalBtns.forEach(modalBtn => {
				modalBtn.setAttribute('role', 'button');
				modalBtn.setAttribute('href', '#');
				modalBtn.addEventListener('click', toggleModal);
				modalBtn.addEventListener('keydown', function (event) {
					if (event.key === 'Enter' || event.key === ' ') {
						toggleModal(event);
					}
				});
				const isOpen = modal.classList.contains('open');
				modalBtn.setAttribute('aria-label', isOpen ? knightowl_translations.close_modal : knightowl_translations.open_modal);
			});
		}

		// Toggle the modal
		function toggleModal(e, ignoreContentClick = false) {
			// gravity forms specific modals
			let modalElementForm = e.target.closest('[data-modal-form]');
			let modalForm = modalElementForm ? modalElementForm.getAttribute('data-modal-form') : null;
			let formModal = document.getElementById(`gravity-form-modal-${modalForm}`);
			let formModalProvider = formModal ? formModal.getAttribute('data-form-provider') : null;
			if (modalForm && formModalProvider === 'gravity_forms') {
				loadGravityFormModal(formModal);
				e.preventDefault();
				return;
			}

			const isOpen = modal.classList.contains('open');
			if (ignoreContentClick && modalContent.contains(e.target)) {
				return;
			}
			modal.classList.toggle('open', !isOpen);
			modal.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
			let modalElementType = e.target.closest('[data-modal-type]');
			let modalType = modalElementType ? modalElementType.getAttribute('data-modal-type') : null;
			let modalElementFullWidth = e.target.closest('[data-modal-full-width]');
			let modalFullWidth = modalElementFullWidth ? modalElementFullWidth.getAttribute('data-modal-full-width') : null;
			let modalElementMaxWidth = e.target.closest('[data-modal-max-width]');
			let modalMaxWidth = modalElementMaxWidth ? modalElementMaxWidth.getAttribute('data-modal-max-width') : null;
			modal.classList.add('type-' + modalType);
			modal.classList.toggle('full-width', modalFullWidth === 'true');

			if (!isOpen) {
				modal.setAttribute('tabindex', '-1');
				modal.focus();
				document.body.classList.add('modal-body-open');
				let modalElementPost = e.target.closest('[data-modal-content]');
				let modalPost = modalElementPost ? modalElementPost.getAttribute('data-modal-content') : null;
				let modalElementPattern = e.target.closest('[data-modal-pattern]');
				let modalPattern = modalElementPattern ? modalElementPattern.getAttribute('data-modal-pattern') : null;
				let modalElementPatternPostId = e.target.closest('[data-modal-pattern-post-id]');
				let modalPatternPostId = modalElementPatternPostId ? modalElementPatternPostId.getAttribute('data-modal-pattern-post-id') : null;
				// let modalElementForm = e.target.closest('[data-modal-form]');
				// let modalForm = modalElementForm ? modalElementForm.getAttribute('data-modal-form') : null;
				let modalElementFormSuccessLocation = e.target.closest('[data-modal-form-success-location]');
				let modalFormSuccessLocation = modalElementFormSuccessLocation ? modalElementFormSuccessLocation.getAttribute('data-modal-form-success-location') : null;

				if (modalMaxWidth) {
					modalHolder.style.maxWidth = modalMaxWidth;
				}

				if (modalType === 'post') {
					if (modalPost && modalForm) {
						loadModalContent(modalPost, modalForm);
					} else {
						loadModalContent(modalPost);
					}
				} else if (modalType === 'pattern') {
					if (modalPattern) {
						loadModalContent(modalPatternPostId, null, null, modalPattern);
					}
				} else if (modalType === 'form') {
					if (modalForm) {
						loadModalContent(null, modalForm, modalFormSuccessLocation);
					}
				} else if (modalType === 'image') {
					let modalElementImage = e.target.closest('[data-modal-image]');
					let modalImage = modalElementImage ? modalElementImage.getAttribute('data-modal-image') : null;
					let modalElementImageAlt = e.target.closest('[data-modal-image-alt]');
					let modalImageAlt = modalElementImageAlt ? modalElementImageAlt.getAttribute('data-modal-image-alt') : '';
					let modalElementImageCaption = e.target.closest('[data-modal-image-caption]');
					let modalImageCaption = modalElementImageCaption ? modalElementImageCaption.getAttribute('data-modal-image-caption') : null;
					modalBody.innerHTML = `
                        <figure>
                            <img src="${escapeHTML(modalImage)}" alt="${escapeHTML(modalImageAlt)}">
                            ${modalImageCaption ? `<figcaption>${escapeHTML(modalImageCaption)}</figcaption>` : ''}
                        </figure>`;
				} else if (modalType === 'video') {
					let modalElementVideo = e.target.closest('[data-modal-video]');
					let modalVideo = modalElementVideo ? modalElementVideo.getAttribute('data-modal-video') : null;
					let modalElementVideoType = e.target.closest('[data-modal-video-type]');
					let modalVideoType = modalElementVideoType ? modalElementVideoType.getAttribute('data-modal-video-type') : null;
					let modalElementVideoRatio = e.target.closest('[data-modal-video-ratio]');
					let modalVideoRatio = modalElementVideoRatio ? modalElementVideoRatio.getAttribute('data-modal-video-ratio') : null;
					modalBody.innerHTML = `<div class="ratio ratio-${modalVideoRatio ? modalVideoRatio : '16x9'}">
                        <iframe src="${getVideoEmbedSrc(modalVideo, modalVideoType)}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>`;
				} else {
					modalBody.innerHTML = `<div class="modal-error-message">${knightowl_translations.oops_content}</div>`;
				}

			} else {
				modal.removeAttribute('tabindex');
				document.body.classList.remove('modal-body-open');
				modalBody.innerHTML = '';
				modal.className = '';
				modal.classList.add('modal');
				modalHolder.style.maxWidth = '';
			}

			e.preventDefault();
		}

		window.addEventListener('click', function (event) {
			if (event.target === modal || event.target.closest('.modal-holder')) {
				toggleModal(event, true);
			}
		});

		const closeModalButton = modal.querySelector('.close-modal');
		if (closeModalButton) {
			closeModalButton.addEventListener('click', function (e) {
				e.stopPropagation();
				toggleModal(e);
			});
		}

		modal.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				toggleModal(event);
			}
		});

		// AJAX load modal content
		function loadModalContent(postId = null, formId = null, modalFormSuccessLocation = null, pattern = null) {
			const requestData = {
				post_id: postId,
				form_id: formId,
				pattern: pattern
			};

			fetch(knightowl_load_data.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': knightowl_load_data.nonce
				},
				body: JSON.stringify(requestData)
			})
				.then(response => {
					if (response.ok) {
						return response.json();
					}
					throw new Error('REST request failed: ' + response.status);
				})
				.then(responseData => {
					if (responseData.success) {
						modalBody.innerHTML = responseData.data;

						if (formId && responseData.form_provider === 'marketo_forms') {
							// Marketo forms
							handleMarketoForms(modalBody, modalFormSuccessLocation);
						} else if (formId && responseData.form_provider === 'hubspot_forms') {
							// HubSpot forms
							const portalId = responseData.portal_id || '';
							handleHubSpotForms(modalBody, formId, portalId, modalFormSuccessLocation);
						}
					} else {
						console.log('An error occurred:', responseData.data);
					}
				})
				.catch(error => {
					console.log('An error occurred:', error);
				});
		}
	}

	function handleHubSpotForms(modalBody, formId, portalId, modalFormSuccessLocation) {
		const hubspotScriptUrl = '//js.hsforms.net/forms/embed/v2.js';

		if (!document.querySelector(`script[src="${hubspotScriptUrl}"]`)) {
			const script = document.createElement('script');
			script.src = hubspotScriptUrl;
			script.onload = () => {
				executeHubSpotFormInit(formId, portalId, modalFormSuccessLocation);
			};
			document.head.appendChild(script);
		} else {
			executeHubSpotFormInit(formId, portalId, modalFormSuccessLocation);
		}
	}

	function executeHubSpotFormInit(formId, portalId, modalFormSuccessLocation = null) {
		const targetContainerId = `hubspotForm_${formId}`;
		const targetContainer = document.getElementById(targetContainerId);

		if (!targetContainer) {
			console.error(`Target container #${targetContainerId} does not exist.`);
			return;
		}

		// Ensure hbspt is available
		if (typeof hbspt === 'undefined') {
			console.error('hbspt is not defined. HubSpot script may not have loaded correctly.');
			return;
		}

		// Create the form
		hbspt.forms.create({
			portalId: portalId,
			formId: formId,
			target: `#${targetContainerId}`,
			onFormSubmitted: function(event) {
				if (modalFormSuccessLocation && isValidUrl(modalFormSuccessLocation)) {
					window.location.href = modalFormSuccessLocation;
				}
			}
		});
	}

	function handleMarketoForms(modalBody, modalFormSuccessLocation) {
		const scripts = Array.from(modalBody.querySelectorAll('script'));

		const marketoScript = scripts.find(s => s.src.includes('forms2.min.js'));
		if (marketoScript) {
			const script = document.createElement('script');
			script.src = marketoScript.src;
			script.onload = () => {
				executeMarketoFormInitScript(modalBody, modalFormSuccessLocation);
			};
			document.head.appendChild(script);

			marketoScript.parentNode.removeChild(marketoScript);
		} else {
			executeMarketoFormInitScript(modalBody, modalFormSuccessLocation);
		}
	}

	function executeMarketoFormInitScript(modalBody, modalFormSuccessLocation = null) {
		// Find and execute the MktoForms2.loadForm script
		const formInitScript = Array.from(modalBody.querySelectorAll('script')).find(s => s.innerHTML.includes('MktoForms2.loadForm'));
		if (formInitScript) {
			const script = document.createElement('script');
			let scriptContent = formInitScript.text || formInitScript.textContent;

			// If modalFormSuccessLocation is provided and is a valid URL, add the onSuccess handler
			if (modalFormSuccessLocation && isValidUrl(modalFormSuccessLocation)) {
				scriptContent += `
				MktoForms2.whenReady(function (form) {
					form.onSuccess(function (values, followUpUrl) {
						location.href = "${modalFormSuccessLocation}";
						return false;
					});
				});
			`;
			}

			script.text = scriptContent;
			document.head.appendChild(script).parentNode.removeChild(script);

			// Remove the original script to keep the DOM clean
			formInitScript.parentNode.removeChild(formInitScript);
		}
	}

	const searchModalTriggers = document.querySelectorAll('.search-modal a');
	searchModalTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function (event) {
			event.preventDefault();
			toggleSearchModal();
		});
	});

	function toggleSearchModal() {
		const isOpen = modal.classList.contains('open');
		modal.classList.toggle('open', !isOpen);
		modal.classList.toggle('type-search', !isOpen);
		modal.setAttribute('aria-hidden', isOpen ? 'true' : 'false');

		if (!isOpen) {
			modal.setAttribute('tabindex', '-1');
			modal.focus();
			document.body.classList.add('modal-body-open');

			const urlParams = new URLSearchParams(window.location.search);
			let searchQuery = urlParams.get('s') || '';
			searchQuery = escapeHTML(decodeURIComponent(searchQuery));

			const currentLang = document.documentElement.lang || navigator.language || 'en';
			const langCode = currentLang.split('-')[0];
			let actionUrl = '/';

			if (langCode !== 'en') {
				actionUrl = `/${langCode}/`;
			}

			modalBody.innerHTML = `
				<div class="search-title">${knightowl_translations.search}</div>
				<form role="search" method="get" id="searchform" action="${actionUrl}">
					<div class="search-wrapper">
						<label class="sr-only" for="s">${knightowl_translations.search}</label>
						<input placeholder="${knightowl_translations.search_placeholder}" type="text" class="form-control search-input" value="${searchQuery}" name="s" id="s" />
						<button type="submit" class="search-submit"><span class="sr-only">${knightowl_translations.submit}</span></button>
					</div>
				</form>`;

			const searchInput = modal.querySelector('.search-input');
			if (searchInput) {
				searchInput.focus();
			}
		} else {
			modal.removeAttribute('tabindex');
			document.body.classList.remove('modal-body-open');
			modalBody.innerHTML = '';
			modal.className = 'modal';
		}
	}

	function loadGravityFormModal(modal) {
		if (modal) {
			modal.classList.add('open');
			modal.setAttribute('aria-hidden', 'false');
			modal.setAttribute('tabindex', '-1');
			modal.focus();
			document.body.classList.add('modal-body-open');

			const closeModalButton = modal.querySelector('.close-modal');
			if (closeModalButton) {
				closeModalButton.addEventListener('click', function (e) {
					e.stopPropagation();
					closeGravityFormModal(modal);
				});
			}

			window.addEventListener('click', function (event) {
				if (event.target === modal || event.target.closest('.modal-holder')) {
					closeGravityFormModal(modal);
				}
			});

			modal.addEventListener('keydown', function (event) {
				if (event.key === 'Escape') {
					closeGravityFormModal(modal);
				}
			});
		}
	}

	function closeGravityFormModal(modal) {
		if (modal) {
			const modalBody = modal.querySelector('.modal-body');
			modal.removeAttribute('tabindex');
			document.body.classList.remove('modal-body-open');
			modalBody.style.display = 'none';
			modal.classList.remove('open');
			modal.setAttribute('aria-hidden', 'true');
			setTimeout(() => {
				modalBody.style.display = '';
			}, 500);
		}
	}
});
